export default {
  HomePage: {
    title: 'Estimator24 — AI Real Estate Valuation',
    description: 'AI-based property valuation for apartments, houses, and residential complexes across Europe and Turkey.'
  },
  AboutPage: {
    title: 'About Estimator24',
    description: 'A platform for property valuation, analytics, and investment insights.'
  },
  PropertyList: {
    title: 'Real Estate Catalog — Estimator24',
    description: 'All apartments, villas, and houses with AI valuation. Search by country, region, and developer.'
  },
  PropertyDetail: {
    title: '{title} — {city} — Estimator24',
    description: 'Detailed property information and AI valuation in {city}.'
  },
  DeveloperList: {
    title: 'Developers — Estimator24',
    description: 'Directory of real estate developers and construction companies.'
  },
  DeveloperDetail: {
    title: '{developer} — Developer — Estimator24',
    description: 'Projects and residential complexes by {developer}.'
  },
  ResidentialComplexShow: {
    title: '{title} — Residential Complex — Estimator24',
    description: 'Description, prices, and layouts for {title}.'
  },
  AgencyList: {
    title: 'Real Estate Agencies — Estimator24',
    description: 'Directory of real estate agencies and their listings.'
  },
  AgencyDetail: {
    title: '{agency} — Real Estate Agency — Estimator24',
    description: 'Listings and contact information for {agency}.'
  },
  NewsList: {
    title: 'Real Estate News — Estimator24',
    description: 'Market trends, analytics, and real estate statistics.'
  },
  NewsDetail: {
    title: '{title} — Estimator24 News',
    description: '{excerpt}'
  },
  StatisticPage: {
    title: 'Real Estate Statistics — Estimator24',
    description: 'Real-time market data on prices, sales, and construction volumes.'
  },
  PrivacyPolicy: {
    title: 'Privacy Policy — Estimator24',
    description: 'User data processing terms and privacy policy details.'
  }
}
